/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { Qualification } from '@/enums';
import type { SemanticICONS } from '@mairistem/composants';

const QUALIFICATION_ATTRIBUTES: Record<
  Qualification,
  {
    title: string;
    name: string;
    icon: SemanticICONS;
  }
> = {
  [Qualification.Diplome]: {
    title: 'Diplôme',
    name: 'diplome',
    icon: 'graduation cap',
  },
  [Qualification.SituationScolaire]: {
    title: 'Situation scolaire',
    name: 'situationScolaire',
    icon: 'book',
  },
  [Qualification.Specialite]: {
    title: 'Spécialité',
    name: 'specialite',
    icon: 'sitemap',
  },
  [Qualification.Profession]: {
    title: 'Profession',
    name: 'profession',
    icon: 'briefcase',
  },
};

export default QUALIFICATION_ATTRIBUTES;
